import { useTranslation } from 'react-i18next';
import { AccordionDetails, Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { Accordion, AccordionPanelsNames, AccordionSummary } from '../Accordion';
import { CommunicationTrackingSummary } from './CommunicationTrackingSummary';
import { CommunicationTrackingRow } from './CommunicationTrackingRow';
import { useCommunicationTracking } from '../../../../../hooks/useCommunicationTracking';

type CommunicationTrackingPanelProps = {
  expanded?: AccordionPanelsNames;
  handleChange: any;
  orderId?: string;
  voucherId?: string;
};

export const CommunicationTrackingPanel = ({
  expanded,
  handleChange,
  orderId,
  voucherId,
}: CommunicationTrackingPanelProps) => {
  const { t } = useTranslation();
  const { status, loading, error } = useCommunicationTracking(orderId, voucherId);

  if (!orderId && !voucherId) {
    return null;
  }

  return (
    <Accordion
      onChange={handleChange}
      expandedPanelName={expanded}
      panelName={AccordionPanelsNames.CommunicationTrackingPanel}>
      <AccordionSummary
        title={t('emailTrackingPanel.title')}
        summaryComponent={<CommunicationTrackingSummary status={status} loading={loading} />}
      />
      <AccordionDetails>
        <Grid container flexDirection="column" gap={2}>
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}

          {!loading && !error && status.events.length === 0 && (
            <Typography color="text.secondary" variant="body2">
              {t('emailTrackingPanel.noEventsFound')}
            </Typography>
          )}

          {!loading && !error && status.events.length > 0 && (
            <>
              <Grid container gap={1} pb={1}>
                <Grid item xs={0.5}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold" />
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    {t('emailTrackingPanel.time')}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    {t('emailTrackingPanel.emailType')}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    {t('emailTrackingPanel.status')}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    {t('emailTrackingPanel.details')}
                  </Typography>
                </Grid>
              </Grid>
              <Divider />

              {status.events.map((event, index) => (
                <CommunicationTrackingRow
                  key={`${event.sendgrid_email_data?.sg_message_id || event.twilio_sms_data?.message_sid}-${
                    event.timestamp
                  }-${index}`}
                  event={event}
                />
              ))}
            </>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
